import { redirect } from 'react-router-dom';
import { UserRole } from '../config';
import { config } from '../config';
import { hasMenu, loadAccess, MenuAction } from './access';
import { menuFor, ModuleKey } from './permissions';
import { getStoredSession, hasValidSession } from './session';

export function protectedLoader(): Response | null {
  if (!hasValidSession()) {
    return redirect('/login');
  }
  return null;
}

export function authLoader(): Response | null {
  if (hasValidSession()) {
    return redirect('/', { replace: true } as any);
  }
  return null;
}

/** @deprecated Role lists are replaced by role-wise menu grants; use `requireMenu`. */
export function requireRoles(...allowedRoles: UserRole[]): () => Response | null {
  return () => {
    const session = getStoredSession();
    if (config.isDev) return null;

    if (!session?.token || !session?.role) {
      return redirect('/login');
    }

    if (!allowedRoles.includes(session.role as UserRole)) {
      return redirect('/unauthorized');
    }

    return null;
  };
}

/**
 * Route guard driven by the role's menu grants (V30): the page opens when the signed-in user's
 * role has the sub-menu (and, if given, the action on it). Loads the grants on first use.
 */
export function requireMenu(code: string, action: MenuAction = 'VIEW'): () => Promise<Response | null> {
  return async () => {
    if (!hasValidSession()) return redirect('/login');
    try {
      await loadAccess();
    } catch {
      return redirect('/unauthorized');
    }
    return hasMenu(code, action) ? null : redirect('/unauthorized');
  };
}

/** Guard for a module key: resolves to the sub-menu it belongs to (see `MODULE_MENUS`). */
export function requireModule(moduleKey: ModuleKey): () => Promise<Response | null> {
  const { menu, action } = menuFor(moduleKey);
  return requireMenu(menu, action);
}
